'use client';

import { c as _c } from "react/compiler-runtime";
import type { ISbStoryData } from '@storyblok/react';
import { useStoryblokLiveData } from 'src/lib/storyblok/live-data';
import { StoryblokComponents } from 'src/lib/storyblok/render';
import { StoryblokPreviewRuntime } from './storyblok-preview-runtime';
type Props = {
  story: ISbStoryData;
  __pageData?: unknown;
};
type StoryblokPreviewContentProps = Pick<Props, 'story' | '__pageData'>;
export function StoryblokPreview(t0) {
  const $ = _c(3);
  const {
    story,
    __pageData
  } = t0;
  let t1;
  if ($[0] !== __pageData || $[1] !== story) {
    t1 = <StoryblokPreviewRuntime><StoryblokPreviewContent story={story} __pageData={__pageData} /></StoryblokPreviewRuntime>;
    $[0] = __pageData;
    $[1] = story;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function StoryblokPreviewContent(t0) {
  const $ = _c(3);
  const {
    story,
    __pageData
  } = t0;
  const liveStory = useStoryblokLiveData(story);
  let t1;
  if ($[0] !== __pageData || $[1] !== liveStory) {
    t1 = <StoryblokComponents story={liveStory} __pageData={__pageData} />;
    $[0] = __pageData;
    $[1] = liveStory;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}